<template>
  <div class="EmergencyMeeting" v-if="videoList.length">
    <div class="title">
      <div>某某应急会议</div>
      <div class="close" @click="close"></div>
    </div>
    <main class="VideoList">
      <ul>
        <li v-for="(item, index) in videoList" :key="index">
          <video autoplay loop muted :src="`/video/${item.name}.mp4`"></video>
          <div class="info">
            <div class="name">{{ item.name }}</div>
            <div class="status">在线</div>
          </div>
          <div class="zoom" @click="zoomIt(item)">
            <img
              ondragstart="return false;"
              src="../../assets/img/pageCard/ShiPinHuiYi/FD.png"
            />
          </div>
        </li>
      </ul>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoList: [],
    }
  },
  methods: {
    close() {
      this.videoList = []
    },

    zoomIt(item) {
      this.$eventBus.$emit('vidoeSource', item)
    },
  },
  mounted() {
    this.$eventBus.$on('videoAmount', (list) => {
      this.videoList = list
    })
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.name) {
          this.videoList = []
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="less" scoped>
.EmergencyMeeting {
  width: 340px;
  height: 860px;
  background: url('../../assets/img/pageCard/ShiPinHuiYi/Meeting.png') no-repeat
    100%;
  pointer-events: all;
  transform: scale(2);

  .title {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 8px 0px 37px;
    box-sizing: border-box;
    & > div:nth-child(1) {
      font-family: '微软雅黑';
      font-weight: bold;
      font-size: 18px;
      background: linear-gradient(to bottom, #fff, #ffffff);
      -webkit-background-clip: text;
      color: transparent;
    }

    .close {
      width: 100px;
      height: 25px;
    }
  }

  .VideoList {
    width: 340px;
    height: 820px;
    padding: 5px 0px 0px;
    box-sizing: border-box;
    & > ul {
      width: 100%;
      height: 815px;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      li {
        width: 305px;
        height: 153px;
        position: relative;
        margin-bottom: 10px;
        border: solid 1px rgb(151, 151, 166);
        box-sizing: border-box;
        & > video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .info {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 30px;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0),
            rgba(0, 0, 0, 1)
          );
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;

          & > div {
            font-family: '微软雅黑';
            font-size: 14px;
            color: #ffffff;
          }

          .status {
            color: #00ffbf;
          }
        }

        .zoom {
          position: absolute;
          top: 6px;
          left: 278px;
          width: 20px;
          height: 20px;
          & > img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
